import { useCallback, useRef } from 'react';
import useEffectOnce from './use-effect-once';
function useMountedState() {
    const mountedRef = useRef(false);
    const get = useCallback(() => mountedRef.current, []);
    useEffectOnce(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
        };
    });
    return get;
}
export default useMountedState;
//# sourceMappingURL=use-mounted.js.map